<script setup>
import { useWebStore } from '~/store/web'
import MachineryHero from '~/components/MachineryHero.vue'
import MachineryTeaser from '~/components/MachineryTeaser.vue'
import MachinerySectionTitle from '~/components/MachinerySectionTitle.vue'
import IconTextCard from '~/components/IconTextCard.vue'
import TextWithLineAfter from '~/components/TextWithLineAfter.vue'
import CtaBanner from '~/components/CtaBanner.vue'

const store = useWebStore()
const machinery = computed(() => store.locale.current.machinery)

store.chosenTab = machinery.value.slug
</script>

<template>
  <div class="w-full bg-white">
    <MachineryHero
      :title="machinery.hero.title"
      :lead="machinery.hero.lead"
      :image="machinery.hero.image"
      :image-alt="machinery.hero.imageAlt"
    />

    <!-- A teasernek nincs `text`-je: az `intro.text` a lentebbi bevezető
         blokkban szerepel, kétszer kiírva ismétlés lenne. A látványterv
         szerint a kártyák felcsúsznak a bannerre, a szekciócím alattuk áll. -->
    <MachineryTeaser
      overlap
      :topics="machinery.topics"
      :hub-slug="machinery.slug"
      :button-text="machinery.cardsButton"
    />

    <section class="w-11/12 mx-auto my-16 lg:w-5/6">
      <MachinerySectionTitle v-reveal class="reveal" :title="machinery.sectionTitle" />

      <div class="grid gap-8 mt-10 lg:grid-cols-2 lg:gap-12">
        <div v-reveal class="reveal reveal-left intro-card bg-light-grey rounded-2xl p-8 text-left lg:p-10">
          <TextWithLineAfter :text="machinery.intro.annotation" />
          <h3 class="InterExtraBold text-2xl mt-8 leading-tight lg:text-3xl">{{ machinery.intro.title }}</h3>
        </div>
        <p v-reveal="1" class="reveal reveal-right InterMedium text-base text-left leading-relaxed lg:text-lg lg:self-center">
          {{ machinery.intro.text }}
        </p>
      </div>

      <div class="grid gap-6 mt-12 sm:grid-cols-2 lg:grid-cols-4">
        <IconTextCard
          v-for="(pillar, index) in machinery.pillars"
          :key="pillar.title"
          v-reveal="index"
          class="reveal"
          :icon="pillar.icon"
          :title="pillar.title"
          :text="pillar.text"
          stacked
        />
      </div>
    </section>

    <CtaBanner
      :title="machinery.cta.title"
      :text="machinery.cta.text"
      :button-text="machinery.cta.button"
    />

    <!-- A ContactUsPage gyökérelemén már ott van az id="enquiry" (a CtaBanner
         erre scrollol), a címet/alcímet pedig maga olvassa a locale cup2/cup3
         kulcsaiból — nincs title/subtitle propja. -->
    <ContactUsPage
      contact-phone="06 20 485 0585"
      contact-email="lukacs.csaba@poliol.hu"
      contact-topic="general"
      class="mt-12"
    />
    <FooterComp />
  </div>
</template>

<style scoped>
/* Bal oldali narancs él: a szürke doboz így nem üres placeholder-hatású. */
.intro-card {
  position: relative;
  overflow: hidden;
}
.intro-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background: linear-gradient(to bottom, #fa4002, #fa8f02);
}
</style>
